module.exports = __webpack_public_path__ + "static/media/name-icon.05fa6ef0.svg";